/** Angular `shortName` pipe: the first letters of the first `numChars` words, upper-cased ("Jo Bloggs" -> "JB"). */
export function shortName(fullName: string, numChars = 2): string {
  return fullName
    .split(' ')
    .slice(0, numChars)
    .map((n) => n[0]?.toUpperCase())
    .join('');
}
